import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import {
  getMultipleFilesByOwnerIdentifier,
  updateBidderForEvent,
} from "services";
import { Button } from "../../../shadcn/components/ui/button";
import CustomMultiplePDFViewer from "../bidder/CustomMultiplePDFViewer";
import CustomRejectionModal from "../bidder/CustomRejectionModal";
import ConfirmationModal from "./ConfirmationModal";
import { useSelector } from "react-redux";
import { validatePaymentRequest } from "services/bidder";

export const BidderDetailsModal = (props: any) => {
  const router = useRouter();
  const [id, setId] = useState<any>();
  const [renderKey, setRenderKey] = useState(0);
  const [bidderData, setBidderData] = useState<any>();
  const [kycFiles, setKycFiles] = useState<any>([]);
  const [showRejectionModal, setShowRejectionModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const banker = useSelector((state: any) => {
    return state.bankerAuth.user;
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const init = async () => {
      if (!props?.bidderData) return;
      setBidderData(props?.bidderData);
      setId(props?.bidderData?.uuid);

      console.log("func run", props?.bidderData);

      if (props?.bidderData) {
        const kycData: any = await getMultipleFilesByOwnerIdentifier(
          props?.bidderData?.uuid,
          props?.bidderData?.created_by === "banker"
            ? "kyc-documents"
            : "signed-bid-request-agreement"
        );

        if (kycData) {
          const filteredKycdata = kycData?.map((item: any) => ({
            id: item?.uuid,
            mime: item?.mime,
            filename: item?.file_name,
          }));
          setKycFiles(filteredKycdata);
          setRenderKey(renderKey + 1);
        }
      }
    };

    init();
  }, [props?.bidderData]);

  const handleAcceptEvent = async () => {
    try {
      const data: any = await updateBidderForEvent({
        uuid: id,
        status: "verified",
        kyc_verified: true,
        emd_amount_paid: true,
        agreement_signed: true,
        application_form_filled: true,
      });
      if (data) {
        props?.refreshPage();
        props?.handleCloseModal(false);
      }
    } catch (err) {
      console.log("error", err);
    }
  };

  const handleRejectEvent = async (cancellationReason: string) => {
    try {
      if (id === "") return;
      setIsLoading(true);
      const data: any = await updateBidderForEvent({
        uuid: id,
        status: "rejected",
        remarks: cancellationReason,
      });
      if (data) {
        props?.refreshPage();
        props?.handleCloseModal(false);
      }
      setIsLoading(false);
    } catch (error: any) {
      setIsLoading(false);
      console.log("check here error", error);
    }
  };
  const handleEMDPaymentAcceptAction = async (
    type: "approved" | "rejected"
  ) => {
    try {
      if (type === "approved") {
        const payload = {
          event_uuid: bidderData?.event_uuid,
          approver_user_uuid: banker.uuid,
          approver_email: banker?.attributes?.find(
            (a: any) => a.type === "email"
          )?.value,
          action_by: "banker",
          approver_name: banker?.profile?.bio?.full_name,
          bidder_uuid: bidderData.uuid,
          approval_status: "approved",
          remarks: "",
        };
        await validatePaymentRequest(payload);
      }
      if (type === "rejected") {
        const payload = {
          event_uuid: bidderData?.event_uuid,
          approver_user_uuid: banker.uuid,
          approver_email: banker?.attributes?.find(
            (a: any) => a.type === "email"
          )?.value,
          action_by: "banker",
          approver_name: banker?.profile?.bio?.full_name,
          bidder_uuid: bidderData.uuid,
          approval_status: "rejected",
          remarks: "",
        };
        await validatePaymentRequest(payload);
      }
    } catch (error) {
      console.log("error: ", error);
    } finally {
      props?.refreshPage();
    }
  };

  return (
    <>
      <div
        className={` ${props?.className}  lg:px-5 lg:py-5  space-y-8 lg:space-y-7 mx-5 mb-5 mt-2 lg:mt-2 `}
      >
        <p className="font-openSans font-semibold text-web-h3">
          Verify KYC Details
        </p>
        {/* PDF Viewer */}
        {
          <div className="mt-4">
            <p className="font-openSans font-normal mb-2 text-mobile-subheading lg:text-web-subheading leading-6  text-brand-textGrey">
              <span className="text-black font-semibold">Bidder Email: </span>
              <br className="lg:hidden" /> {bidderData?.email}
            </p>
            <p className="font-openSans font-normal mb-2 text-mobile-subheading lg:text-web-subheading  leading-6  text-brand-textGrey">
              <span className="font-semibold text-black">Bidder Name: </span>{" "}
              <br className="lg:hidden" /> {bidderData?.bidder_name}
            </p>
            <p className="font-openSans font-normal mb-2 text-mobile-subheading lg:text-web-subheading leading-6  text-brand-textGrey">
              <span className="font-semibold text-black">
                Event Listing ID:{" "}
              </span>
              <br className="lg:hidden" /> {bidderData?.event_id}
            </p>
            {bidderData?.status === "rejected" && bidderData?.remarks && (
              <p className="font-openSans font-normal mb-2 text-mobile-subheading lg:text-web-subheading leading-6  text-brand-textGrey">
                <span className="font-semibold text-black">
                  Rejection Reason:
                </span>
                <br className="lg:hidden" /> {bidderData?.remarks}
              </p>
            )}
            {/* Accept Reject Functionality */}
            {bidderData?.status === "pending" && (
              <div className="w-full flex flex-col md:flex-row justify-center md:justify-start  mt-10">
                <div className="flex space-x-3">
                  <Button
                    disabled={
                      isLoading ||
                      bidderData?.status === "verified" ||
                      bidderData?.status === "rejected"
                    }
                    // onClick={handleAcceptEvent}
                    onClick={() => {
                      if (
                        bidderData?.approval_status === "rejected" &&
                        bidderData?.emd_payment_uuid
                      ) {
                        alert(
                          "EMD payment was rejected by the approver. Please contact Auction Bazaar support. You cannot proceed further."
                        );
                        return;
                      }
                      if (
                        bidderData?.approval_status !== "approved" &&
                        bidderData?.emd_payment_uuid
                      ) {
                        alert(
                          "EMD Payment Require Approval. Please review or approve as AO."
                        );
                        return;
                      }
                      setShowConfirmationModal(true);
                    }}
                    className="px-5 py-3 w-[140px] md:w-[125px]"
                  >
                    Accept
                  </Button>
                  <Button
                    disabled={
                      isLoading ||
                      bidderData?.status === "verified" ||
                      bidderData?.status === "rejected"
                    }
                    onClick={() => {
                      setShowRejectionModal(true);
                    }}
                    className="bg-[#fafafabb] border text-[#B60100] px-5 py-3 w-[140px] md:w-[125px] hover:bg-brand-borderLightGray"
                  >
                    Reject
                  </Button>
                </div>
              </div>
            )}
            <CustomMultiplePDFViewer
              mode="sidebar"
              key={renderKey}
              handleChange={setKycFiles}
              allowedMimeTypes={["application/pdf"]}
              property_uuid={props?.bidderData?.uuid}
              owner_service_type="kyc-documents"
              data={kycFiles}
            />
            {bidderData?.emd_payment_uuid && (
              <div className="my-6">
                <div className="font-openSans text-sm font-semibold">
                  EMD Payment details
                </div>
                <div className="text-sm py-4">
                  <div className="rounded-lg px-4 py-3 inline-block">
                    <span className="mr-2 font-medium">
                      EMD Payment Status:
                    </span>
                    <span
                      className={`font-semibold capitalize ${
                        bidderData?.approval_status === "approved"
                          ? "text-brand-bgSuccessGreen"
                          : bidderData?.approval_status === "rejected"
                          ? "text-brand-textRed"
                          : "text-brand-textBlack"
                      }`}
                    >
                      {bidderData?.approval_status}
                    </span>
                  </div>
                </div>
                <div>
                  <h4 className="text-sm text-brand-textBlack mb-3">
                    Payment Receiver Details
                  </h4>
                  <div className="space-y-2 text-brand-textBlack text-xs pb-4 px-4 grid md:grid-cols-2">
                    <div>
                      <span className="font-medium text-brand-orange mr-2">
                        Receiver Name:
                      </span>
                      <span className="capitalize text-xs font-semibold tracking-wide">
                        {bidderData?.emd_payment_data?.approver_name || ""}
                      </span>
                    </div>

                    <div>
                      <span className="font-medium text-brand-orange mr-2">
                        Receiver Email:
                      </span>
                      {bidderData?.emd_payment_data?.approver_email}
                    </div>

                    <div className="capitalize">
                      <span className="font-medium text-brand-orange mr-2">
                        Receiver Mobile Number:
                      </span>
                      {bidderData?.emd_payment_data?.approver_mobile || ""}
                    </div>

                    <div>
                      <span className="font-medium text-brand-orange mr-2">
                        Payment Received Date:
                      </span>
                      {bidderData?.emd_payment_data?.approval_date || ""}
                    </div>
                  </div>
                </div>
                {bidderData?.approval_status === "submitted" && (
                  <div className="flex justify-center gap-10 py-4">
                    <div className="space-x-3 md:space-x-3 w-full">
                      <Button
                        onClick={async () => {
                          await handleEMDPaymentAcceptAction("approved");
                        }}
                        className={`px-5 py-3 w-full`}
                      >
                        Approve EMD Payment
                      </Button>
                    </div>
                    <div className="space-x-3 md:space-x-3 w-full">
                      <Button
                        variant="ghost"
                        onClick={async () => {
                          await handleEMDPaymentAcceptAction("rejected");
                        }}
                        className={`px-5 py-3 w-full border`}
                      >
                        Reject EMD Payment
                      </Button>
                    </div>
                  </div>
                )}
                <div className="relative p-2">
                  <div className="absolute top-0 right-0 flex items-center gap-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 text-brand-headingBlue"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5m0 0l5-5m-5 5V4"
                      />
                    </svg>
                    <a
                      href={`${`${process.env.NEXT_PUBLIC_IMAGIX_URL}/${bidderData?.emd_payment_uuid}`}?dl=demand-draft-${Date.now()}.jpg`}
                      // target="_blank"
                      // rel="noopener noreferrer"
                      download={`demand-draft-${Date.now()}.jpg`}
                      className="inline-flex text-sm tracking-wide font-openSans items-center text-brand-headingBlue hover:underline"
                    >
                      Download
                    </a>
                  </div>
                  <div className="flex justify-center md:justify-end mt-4 ">
                    <img
                      src={`${process.env.NEXT_PUBLIC_IMAGIX_URL}/${bidderData?.emd_payment_uuid}`}
                      alt="Demand Draft"
                      className="w-full h-auto max-h-[370px] min-h-[200px] object-contain"
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        }
      </div>
      {showConfirmationModal && (
        <ConfirmationModal
          onCancel={() => setShowConfirmationModal(false)}
          onApprove={handleAcceptEvent}
          isLoading={isLoading}
        />
      )}
      {showRejectionModal && (
        <CustomRejectionModal
          handleSubmit={handleRejectEvent}
          modalType={"rejection"}
          onClose={setShowRejectionModal}
          isLoading={isLoading}
        />
      )}
    </>
  );
};

export default BidderDetailsModal;
